module.exports = "/_next/static/images/team-staffing-expansion-service-3-be9a987b99d37600f086248b9eff5898.webp";